export var FontType;
(function (FontType) {
    FontType["default"] = "var(--font-default)";
    FontType["heading"] = "var(--font-heading)";
})(FontType || (FontType = {}));
export var TitleFontSize;
(function (TitleFontSize) {
    TitleFontSize["XS"] = "22px";
    TitleFontSize["S"] = "26px";
    TitleFontSize["M"] = "34px";
    TitleFontSize["L"] = "40px";
    TitleFontSize["XL"] = "48px";
})(TitleFontSize || (TitleFontSize = {}));
export var TextFontSize;
(function (TextFontSize) {
    TextFontSize["XXXS"] = "9px";
    TextFontSize["XXS"] = "12px";
    TextFontSize["XS"] = "14px";
    TextFontSize["S"] = "15px";
    TextFontSize["M"] = "16px";
    TextFontSize["L"] = "18px";
    TextFontSize["XL"] = "22px";
    TextFontSize["XXL"] = "24px";
})(TextFontSize || (TextFontSize = {}));
export var FontWeight;
(function (FontWeight) {
    FontWeight[FontWeight["normal"] = 400] = "normal";
    FontWeight[FontWeight["bold"] = 700] = "bold";
})(FontWeight || (FontWeight = {}));
export var LetterSpacing;
(function (LetterSpacing) {
    LetterSpacing["S"] = "var(--font-default-spacing-s)";
    LetterSpacing["M"] = "var(--font-default-spacing-m)";
    LetterSpacing["L"] = "var(--font-default-spacing-l)";
})(LetterSpacing || (LetterSpacing = {}));
export var TitleLetterSpacing;
(function (TitleLetterSpacing) {
    TitleLetterSpacing["S"] = "var(--font-heading-spacing-s)";
    TitleLetterSpacing["M"] = "var(--font-heading-spacing-m)";
})(TitleLetterSpacing || (TitleLetterSpacing = {}));
export var LineHeight;
(function (LineHeight) {
    LineHeight["XXXXS"] = "var(--font-text-line-height, 18px)";
    LineHeight["XXXS"] = "var(--font-text-line-height, 21px)";
    LineHeight["XXS"] = "var(--font-text-line-height, 23px)";
    LineHeight["XS"] = "var(--font-text-line-height, 24px)";
    LineHeight["S"] = "var(--font-text-line-height, 29px)";
    LineHeight["M"] = "var(--font-text-line-height, 32px)";
})(LineHeight || (LineHeight = {}));
export var TitleLineHeight;
(function (TitleLineHeight) {
    TitleLineHeight["XS"] = "var(--font-heading-line-height-xs)";
    TitleLineHeight["S"] = "var(--font-heading-line-height-s)";
    TitleLineHeight["M"] = "41px";
    TitleLineHeight["L"] = "48px";
    TitleLineHeight["XL"] = "58px";
})(TitleLineHeight || (TitleLineHeight = {}));
//# sourceMappingURL=index.js.map